if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          details: this.querySelector('details'),
          urlInput: this.querySelector('input'),
          copyButton: this.querySelector('.share-button__copy'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]')
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : window.location.href;

        this.init();
      }

      init() {
        if (navigator.share && this.elements.shareButton) {
          // Native share supported
          if (this.elements.details) this.elements.details.style.display = 'none';

          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({
              url: this.urlToShare,
              title: document.title
            });
          });
        } else {
          // Fallback behavior
          if (this.elements.details) this.elements.details.style.display = '';
          this.setupFallback();
        }
      }

      setupFallback() {
        if (!this.elements.details) return;

        // button now opens <details>
        if (this.elements.shareButton) {
          this.elements.shareButton.addEventListener('click', () => {
            this.elements.details.setAttribute('open', '');
          });
        }

        if (this.elements.copyButton) {
          this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', this.close.bind(this));
        }
      }

      copyToClipboard() {
        if (this.elements.urlInput) {
          navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
            this.showSuccess();
          }).catch(() => {
            this.elements.urlInput.select();
            document.execCommand('copy');
            this.showSuccess();
          });
        }
      }

      showSuccess() {
        if (this.elements.successMessage) {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = 'Link copied to clipboard!';
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }
      }

      close() {
        if (this.elements.details) {
          this.elements.details.removeAttribute('open');
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) {
          this.elements.urlInput.value = url;
        }
      }
    }
  );
}
